import { formLabelLine } from './form-label-line.js'
import { labelWithDescriptionLine } from './label-with-description-line.js'

export function formLabelWithDescriptionLine(
  name: string,
  label: string,
  requiredStar: string,
  descriptionJSX: string,
  indent: string,
  className?: string
): string {
  return labelWithDescriptionLine(
    formLabelLine(name, label, requiredStar, className),
    descriptionJSX,
    indent
  )
}
